var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgM03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.5C4.785 1.5 3.1875 3.0975 3.1875 5.0625C3.1875 6.99 4.695 8.55 6.66 8.6175C6.72 8.61 6.78 8.61 6.825 8.6175C6.84 8.6175 6.8475 8.6175 6.8625 8.6175C6.87 8.6175 6.87 8.6175 6.8775 8.6175C8.7975 8.55 10.305 6.99 10.3125 5.0625C10.3125 3.0975 8.715 1.5 6.75 1.5Z",
    fill: "#0F55DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5588 10.6127C8.46625 9.21766 5.05375 9.21766 2.94625 10.6127C1.99375 11.2502 1.46875 12.1127 1.46875 13.0352C1.46875 13.9577 1.99375 14.8127 2.93875 15.4427C3.98875 16.1477 5.36875 16.5002 6.74875 16.5002C8.12875 16.5002 9.50875 16.1477 10.5588 15.4427C11.5037 14.8052 12.0288 13.9502 12.0288 13.0202C12.0213 12.0977 11.5037 11.2427 10.5588 10.6127Z",
    fill: "#0F55DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.992 5.50507C15.112 6.96007 14.077 8.23507 12.6445 8.40757C12.637 8.40757 12.637 8.40757 12.6295 8.40757H12.607C12.562 8.40757 12.517 8.40757 12.4795 8.42257C11.752 8.46007 11.0845 8.22757 10.582 7.80007C11.3545 7.11007 11.797 6.07507 11.707 4.95007C11.6545 4.34257 11.4445 3.78757 11.1295 3.31507C11.4145 3.17257 11.7445 3.08257 12.082 3.05257C13.552 2.92507 14.8645 4.02007 14.992 5.50507Z",
    fill: "#0F55DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4922 12.4423C16.4322 13.1698 15.9672 13.7998 15.1872 14.2273C14.4372 14.6398 13.4922 14.8348 12.5547 14.8123C13.0947 14.3248 13.4097 13.7173 13.4697 13.0723C13.5447 12.1423 13.1022 11.2498 12.2172 10.5373C11.7147 10.1398 11.1297 9.82481 10.4922 9.59231C12.1497 9.11231 14.2347 9.43481 15.5172 10.4698C16.2072 11.0248 16.5597 11.7223 16.4922 12.4423Z",
    fill: "#0F55DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM03);
export default __webpack_public_path__ + "static/media/m_03.700221a954e4ae1081bc0f28058ebc6d.svg";
export { ForwardRef as ReactComponent };